import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkBarStyle } from './uitk-bar-style.esm.js';
import styles from '../../../uitk-calendar.css';
var getClassNameList = classNames.bind(styles);
var UitkEventBar = function (props) {
  var _a = props.size,
    size = _a === void 0 ? 'medium' : _a,
    _b = props.eventItems,
    eventItems = _b === void 0 ? [] : _b,
    _c = props.splitDay,
    splitDay = _c === void 0 ? false : _c,
    icon = props.icon;
  var wrapperClassNames = getClassNameList('uitk-event-bar', "uitk-event-bar-size-".concat(size), {
    'uitk-event-bar-split-day': splitDay,
    'uitk-event-bar-has-icon': icon
  });
  return React.createElement("div", {
    className: wrapperClassNames
  }, eventItems.map(function (eventItem, index) {
    return React.createElement(UitkBarStyle, __assign({
      key: index
    }, eventItem), size !== 'small' && icon && React.createElement("div", {
      className: "uitk-event-bar-".concat(eventItem.theme, "-icon-background")
    }, icon));
  }));
};
UitkEventBar.displayName = 'UitkEventBar';
export { UitkEventBar };